var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"LandscapeNavLink",class:{'has-menu': _vm.hasMenu},attrs:{"exact":!_vm.matchChildrenRoutes,"tag":"li","to":{
    name: _vm.to,
    params: {
      actor: _vm.selectedActor && _vm.selectedActor.pathArr,
      landscapeSlug: _vm.$route.params.landscapeSlug
    }
  }}},[_c('a',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }